import React, { Component, PropTypes } from 'react';
import { call, cond, always, equals, either, T, merge, isNil, not } from 'ramda';
import { FontIcon } from 'material-ui';
import { browser } from 'bowser';
const Dropbox = require('../../../www/images/dropbox.png');
const GoogleDrive = require('../../../www/images/google-drive.png');
const OneDrive = require('../../../www/images/onedrive.png');
const Box = require('../../../www/images/box.png');
import { Document, Page } from 'react-pdf/build/entry.webpack';
import debounce from 'lodash.debounce';

const notEqual = (first, second) => not(equals(first, second));

const propTypes = {
  index: PropTypes.number,
  onThumbnailSelect: PropTypes.func,
  file: PropTypes.object,
  isSelected: PropTypes.bool,
  selectedBorderStyle: PropTypes.object,
  onPreviewClick: PropTypes.func,
  updateUserHovering: PropTypes.func,
  isUserHovering: PropTypes.bool,
  hoverEffect: PropTypes.bool,
  showVideoControls: PropTypes.bool,
  downloadOneFile: PropTypes.func,
  isUploadingFile: PropTypes.bool,
  minHeight: PropTypes.string, // eg 40px
  maxHeight: PropTypes.string,
  inDialog: PropTypes.bool,
};

class Thumbnail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      videoPlaying: false,
      fullScreen: false,
      muted: false,
      numOfPDFPages: null,
    };
  }

  componentDidMount() {
    window.addEventListener('fullscreenchange', this.onFullScreenChange, false);
    window.addEventListener('webkitfullscreenchange', this.onFullScreenChange, false);
    window.addEventListener('mozfullscreenchange', this.onFullScreenChange, false);
  }

  onFullScreenChange() {
    const fullscreenElement = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement;
    this.setState({ fullScreen: !isNil(fullscreenElement) });
  }

  render() {
    const {
      file,
      index,
      onThumbnailSelect,
      isSelected,
      selectedBorderStyle,
      onPreviewClick,
      updateUserHovering,
      isUserHovering,
      hoverEffect, // should mask show on hover - false means it's being viewed in a dialog
      showVideoControls,
      downloadOneFile,
      isUploadingFile,
      minHeight,
      maxHeight,
      inDialog,
    } = this.props;

    const PDFHeight = file.mediaType === 'application/pdf' ? '440px' : '';
    const outerDivStyle = { height: hoverEffect ? '128px' : PDFHeight, pointerEvents: isUploadingFile ? 'none' : '', overflowY: file.mediaType === 'application/pdf' ? 'scroll' : '' };
    const genericStyle = { maxWidth: '100%', maxHeight: maxHeight || '100%', verticalAlign: 'middle', minHeight: minHeight || '' };
    const videoButtonStyle = { cursor: 'pointer', color: 'rgba(0, 0, 0, 0.54)' };
    const isVideo = either(equals('video/mp4'), equals('video/quicktime'));
    const onThumbnailClick = debounce(() => isUserHovering ? onPreviewClick(index) : onThumbnailSelect(merge(file, { index }), 200));

    const videoControls = (action) => {
      call(cond([
        [equals('play'), () => {
          this.setState({ videoPlaying: true });
          this.refs.videoRef.play();
        }],
        [equals('pause'), () => {
          this.setState({ videoPlaying: false });
          this.refs.videoRef.pause();
        }],
        [equals('fullScreen'), () => {
          this.setState({ fullScreen: true });
          if (equals(browser.name, 'Chrome') || equals(browser.name, 'Safari') || equals(browser.name, 'Internet Explorer')) return this.refs.videoRef.webkitRequestFullScreen();
          if (equals(browser.name, 'Firefox')) return this.refs.videoRef.mozRequestFullScreen();
          if (equals(browser.name, 'Internet Explorer')) return this.refs.videoRef.msRequestFullscreen();
          return this.refs.videoRef.requestFullscreen();
        }],
      ]), action);
    };

    const generateIconForCloudDrive = (imageSrc, imageSize) => {
      return (
        <a href={file.url} target="_blank">
          <img
            src={imageSrc}
            style={{
              width: hoverEffect && notEqual(imageSrc, Dropbox) ? '70px' : imageSize,
              verticalAlign: 'middle',
            }}
          />
        </a>
      );
    };

    const getIconForCloudDrive = (storageProvider) => call(cond([
      [equals('Dropbox'), always(generateIconForCloudDrive(Dropbox, '55px'))],
      [equals('Google Drive'), always(generateIconForCloudDrive(GoogleDrive, '100px'))],
      [equals('OneDrive'), always(generateIconForCloudDrive(OneDrive, '100px'))],
      [equals('Box'), always(generateIconForCloudDrive(Box, '100px'))],
      [T, always(
        <a href={file.url} target="_blank">
          <FontIcon
            className="tc-icon-cloud_circle"
            style={{ color: 'rgba(138,138,138,.5)', verticalAlign: 'middle', fontSize: '40px' }}
            hoverColor="#00bcd4"
          />
        </a>
      )],
    ]), storageProvider);

    const getVideoPlayerButtons = (button) => call(cond([
      [equals('play'), () => {
        return (
          <FontIcon
            className="tc-icon-play_arrow"
            onClick={() => videoControls('play')}
            style={videoButtonStyle}
          />
        );
      }],
      [equals('pause'), () => {
        return (
          <FontIcon
            className="tc-icon-pause"
            onClick={() => videoControls('pause')}
            style={videoButtonStyle}
          />
        );
      }],
      [equals('fullScreen'), () => {
        return (
          <FontIcon
            className="tc-icon-fullscreen"
            onClick={() => videoControls('fullScreen')}
            style={videoButtonStyle}
          />
        );
      }],
      [equals('mute'), () => {
        return (
          <FontIcon
            className="tc-icon-volume_up"
            onClick={() => this.setState({ muted: true })}
            style={videoButtonStyle}
          />
        );
      }],
      [equals('unmute'), () => {
        return (
          <FontIcon
            className="tc-icon-volume_off"
            onClick={() => this.setState({ muted: false })}
            style={videoButtonStyle}
          />
        );
      }],
    ]), button);

    return (
      <div
        className={hoverEffect ? 'image-container effect' : ''}
        onClick={hoverEffect ? onThumbnailClick : undefined}
        style={isSelected ? merge(outerDivStyle, selectedBorderStyle) : outerDivStyle}
      >
        {
          call(cond([
            [either(equals('image/png'), equals('image/jpeg')), always(
              <img
                id={`locationImage${index}`}
                src={Number(file.size) > 10 && !inDialog ? '' : file.url}
                style={isSelected ? merge({ marginTop: '-2px' }, genericStyle) : genericStyle}
              />
            )],
            [isVideo, always(
              <div>
                <video style={genericStyle} ref="videoRef" muted={this.state.muted}>
                  <source
                    id={`locationImage${index}`}
                    src={Number(file.size) > 2 && !inDialog ? '' : file.url}
                    type="video/mp4"
                  />
                </video>
                {
                  showVideoControls ?
                    <div style={{ border: '1px solid #BDBDBD', height: '25px', verticalAlign: 'middle' }}>
                      <span style={{ float: 'left' }}>
                        {this.state.videoPlaying ? getVideoPlayerButtons('pause') : getVideoPlayerButtons('play')}
                        {this.state.fullScreen ? getVideoPlayerButtons('exitFullScreen') : getVideoPlayerButtons('fullScreen')}
                      </span>
                      <span style={{ float: 'right', marginRight: '3px' }}>
                        {this.state.muted ? getVideoPlayerButtons('unmute') : getVideoPlayerButtons('mute')}
                      </span>
                    </div> : <span/>
                }
              </div>
            )],
            [equals('application/pdf'), always(
              <div style={{ border: '2px solid #D3D3D3', width: '100%', display: 'flex', justifyContent: 'center', paddingTop: hoverEffect ? '3px' : '' }}>
                <Document file={file.url} onLoadSuccess={({ numPages }) => this.setState({ numOfPDFPages: numPages })}>
                  {
                    hoverEffect ?
                      <Page pageNumber={1} width={85} /> :
                      Array.from(
                        new Array(this.state.numOfPDFPages),
                        (el, i) => (
                          <Page
                            key={`page_${i + 1}`}
                            pageNumber={i + 1}
                            scale={0.95}
                          />
                        ),
                      )
                  }
                </Document>
              </div>
            )],
            [either(equals('application/vnd.ms-powerpoint'), equals('application/vnd.openxmlformats-officedocument.presentationml.presentation')), always(
              <div>
                <FontIcon
                  className="tc-icon-subscriptions"
                  style={{ color: 'rgba(138,138,138,.5)', verticalAlign: 'middle', fontSize: '40px', cursor: 'pointer' }}
                  hoverColor="#00bcd4"
                  onClick={() => downloadOneFile()}
                />
              </div>
            )],
            [equals('CloudDrive'), always(getIconForCloudDrive(file.storageProvider))],
            [T, always('')],
          ]), file.mediaType)
        }
        {
          hoverEffect ?
            <div className="video-playbutton-mask">
              <FontIcon
                className="tc-icon-zoom_in"
                style={{ color: '#ffffff', verticalAlign: 'middle', fontSize: '50px' }}
                onClick={onThumbnailClick}
                onMouseEnter={() => updateUserHovering(true)}
                onMouseLeave={() => updateUserHovering(false)}
              />
            </div> : <span/>
        }
      </div>
    );
  }
}

Thumbnail.propTypes = propTypes;

export default Thumbnail;



// WEBPACK FOOTER //
// ./src/app/components/marketing-materials/generate-preview.jsx